import CountUp from "react-countup";

const MediaFotos = ({ visualizacoes }) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-center">
      <p className="text-sm text-gray-500">Fotos Visualizadas / Visita</p>
      <p className="text-2xl font-bold text-indigo-600">
        <CountUp
          end={isNaN(visualizacoes) ? 0 : visualizacoes}
          duration={1.5}
        />
      </p>
    </div>
  );
};

export default MediaFotos;
